import styled from "styled-components"
import Colors from "../../theme/colors"

const Tag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 4px;
  margin-right: 8px;
  margin-bottom: 8px;
  background-color: ${Colors.white};
  border: 1px solid ${Colors.lightGrey};
  border-radius: 4px;
  color: ${Colors.darkGrey};
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  box-sizing: border-box;
`
export default Tag
